<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough" transform="matrix(-1,0,0,1,28,0)">
        <path
          d="M14.712915,5.95809C14.183923,5.79939,13.883739,5.24191,14.042437,4.712915C14.201135,4.183923,14.758618,3.883739,15.28761,4.042437C15.28761,4.042437,25.287599999999998,7.04244,25.287599999999998,7.04244C26.2378,7.327500000000001,26.2378,8.67303,25.287599999999998,8.95809C25.287599999999998,8.95809,15.28761,11.95809,15.28761,11.95809C14.758618,12.11679,14.201135,11.816600000000001,14.042437,11.28761C13.883739,10.75862,14.183923,10.201139999999999,14.712915,10.04244C14.712915,10.04244,21.52016,8.00026,21.52016,8.00026C21.52016,8.00026,14.712915,5.95809,14.712915,5.95809C14.712915,5.95809,14.712915,5.95809,14.712915,5.95809Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'LessThan',
} as DefineComponent
</script>
